export default "mutation saveRole($roleDto: RolePermissionDto) {\n  saveRole(roleDto: $roleDto) \n}";